<template>
  <GlobalWindow
    :title="title"
    :visible.sync="visible"
    :confirm-working="isWorking"
    @confirm="confirm"
  >
    <el-form :model="form" ref="form" :rules="rules">
      <el-form-item label="文章标题" prop="title">
        <el-input v-model="form.title" placeholder="请输入文章标题" v-trim />
      </el-form-item>

      <el-form-item label="所属版块" prop="tagForSector">
        <el-select
          v-model="form.tagForSector"
          placeholder="请选择所属板块"
          @change="changeSector"
        >
          <el-option
            v-for="(item, itemIndex) in tagList"
            :key="itemIndex"
            :label="item.label"
            :value="Number(item.code)"
          >
          </el-option>
        </el-select>
      </el-form-item>

      <el-form-item label="所属标签" prop="tagList">
        <el-select
          :value="tagListMap"
          placeholder="请选择所属标签"
          multiple
          filterable
          remote
          reserve-keyword
          :remote-method="remoteMethod"
          :loading="tagLoading"
          @change="setTagList"
        >
          <el-option
            v-for="(item, itemIndex) in textTagList"
            :key="itemIndex"
            :label="item.tagName"
            :value="item.id"
          >
          </el-option>
        </el-select>
      </el-form-item>

      <el-form-item label="文章状态" prop="status">
        <el-select v-model="form.status" placeholder="请选择文章状态">
          <el-option
            v-for="(item, itemIndex) in statusList"
            :key="itemIndex"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
      </el-form-item>

      <el-form-item label="所属用户" prop="forUserId">
        <el-select
          v-model="form.forUserId"
          placeholder="请选择所属用户"
          filterable
          remote
          reserve-keyword
          :remote-method="getUserList"
          @keypress.enter.native="search"
        >
          <el-option
            v-for="(item, itemIndex) in forUserList"
            :key="itemIndex"
            :label="item.mobile"
            :value="item.id"
          >
            <div style="display: flex; align-items: center">
              <el-avatar
                shape="circle"
                style="width: 50px; height: 50px"
                fit="cover"
                :src="imgUrl + item.avatar"
              ></el-avatar>
              <div style="padding-left: 8px">
                <span
                  ><b>{{ item.username }}</b></span
                >
                <div>手机: {{ item.mobile }}</div>
              </div>
            </div>
          </el-option>
        </el-select>
      </el-form-item>

      <el-form-item label="文章内容" prop="context">
        <el-input
          type="textarea"
          :autosize="{ minRows: 2, maxRows: 12 }"
          v-model="form.context"
          placeholder="请输入文章内容"
          v-trim
        />
      </el-form-item>

      <el-form-item label="文章图片,最多上传3张" prop="fileList">
        <el-upload
          :action="uploadAction"
          :limit="3"
          :before-upload="beforeUpload"
          :on-exceed="onExceed"
          :file-list="fileList"
          list-type="picture-card"
          :on-success="onSuccess"
          :on-remove="handleRemove"
          accept="image/*,video/*"
          :http-request="httpRequest"
        >
          <div slot="file" slot-scope="{ file }">
            <div class="upload-item">
              <!-- 图片预览 -->
              <el-image
                v-if="!isVideo(file.accessUri)"
                :src="imgUrl + file.accessUri"
                fit="cover"
                class="upload-img"
              >
                <template #error>
                  <i class="el-icon-picture"></i>
                </template>
              </el-image>

              <!-- 视频预览，点击弹窗 -->
              <div
                v-else
                class="upload-video-preview"
                @click="previewVideo(file)"
              >
                <i class="el-icon-video-play"></i>
                <span>{{ file.name }}</span>
              </div>

              <!-- 删除按钮 -->
              <el-button
                v-if="fileList.length > 0"
                class="delete-btn"
                icon="el-icon-delete"
                @click="handleRemove(file, fileList)"
                size="mini"
              />
            </div>
          </div>

          <i class="el-icon-plus"></i>
        </el-upload>
      </el-form-item>
    </el-form>

    <!-- 视频弹窗 -->
    <el-dialog
      :visible.sync="videoDialogVisible"
      width="80%"
      @close="closeVideoDialog"
    >
      <video controls :src="videoSrc" class="video-player"></video>
    </el-dialog>
  </GlobalWindow>
</template>

<script lang="ts">
import BaseOpera from '@/components/base/BaseOpera'
import GlobalWindow from '@/components/common/GlobalWindow'
import { fetchList } from '../../api/rentHouse/communityArticleTag'
import { fetchList as fetchListUser } from '../../api/system/user'
import request from '@/utils/request'
export default {
  name: 'OperaCommunityArticleWindow',
  extends: BaseOpera,
  components: { GlobalWindow },
  props: {
    tagList: {
      type: Array,
      default: () => []
    }
  },
  data () {
    return {
      // 表单数据
      form: {
        id: null,
        title: '',
        context: '',
        tagList: [],
        tagForSector: '',
        pic: '',
        status: '',
        forUserId: ''
      },
      imgUrl: process.env.VUE_APP_API_IMG,
      uploadAction: '',
      uploadActionFree: false,
      base: '/upload/image',
      base1: '/upload/attach',
      fileList: [],
      forUserList: [],
      textTagList: [],
      tagLoading: false,
      statusList: [
        { label: '待审核', value: 1 },
        { label: '已审核', value: 2 },
        { label: '已驳回', value: 3 }
      ],
      // 验证规则
      rules: {},
      videoDialogVisible: false,
      videoSrc: ''
    }
  },
  created () {
    this.config({
      api: '/rentHouse/communityArticle',
      'field.id': 'id'
    })

    const extendsOpen = this.open.bind(this)

    this.open = (title, target) => {
      const picList = (target && target.pic) || ''

      this.fileList = picList
        ? picList.split(',').map((item) => {
          return {
            accessUri: item,
            url: process.env.VUE_APP_API_IMG + item
          }
        })
        : []

      extendsOpen(title, target)

      this.$nextTick(() => {
        this.remoteMethod()
        this.getUserList()
      })
    }
  },
  computed: {
    tagListMap () {
      return this.form.tagList.map((item) => {
        return Number(item.id)
      })
    }
  },
  methods: {
    generateFileExtensionRegex (extensions) {
      // 对数组中的每个扩展名进行转义，以确保特殊字符（如点号）被正确处理。
      const escapedExtensions = extensions.map((ext) =>
        ext.replace(/\./g, '\\.')
      )

      // 使用管道符号 (|) 将转义后的扩展名连接起来，形成一个正则表达式模式。
      const pattern = `(${escapedExtensions.join('|')})`

      // 创建一个新的正则表达式对象，并返回它。
      return new RegExp(pattern, 'i') // 'i' 标志使匹配不区分大小写
    },
    isVideo (item) {
      const regExp = this.generateFileExtensionRegex([
        '.mp4',
        '.m4v',
        '.mov',
        '.flv',
        '.m3u8',
        '3gp'
      ])
      return regExp.test(item)
    },
    // 视频点击打开弹窗
    previewVideo (file) {
      this.videoSrc = file.url
      this.videoDialogVisible = true
    },

    // 关闭视频弹窗
    closeVideoDialog () {
      this.videoSrc = ''
      this.videoDialogVisible = false
    },
    async getUserList (keyword) {
      const res = await fetchListUser({
        page: 1,
        capacity: 50,
        model: {
          username: '',
          nickName: '',
          realname: '',
          mobile: keyword
        },
        sorts: [{ property: 'CREATE_TIME', direction: 'DESC' }]
      })

      this.forUserList = res.records
    },
    changeSector (event) {
      this.textTagList = []
      this.form.tagList = []
      this.form.tagForSector = event
      this.remoteMethod()
    },
    async setTagList (event) {
      this.form.tagList = event.map((item) => {
        return {
          id: item
        }
      })
    },
    async remoteMethod (query) {
      this.tagLoading = true
      const resData = await fetchList({
        page: 1,
        capacity: 50,
        model: { id: '', tagName: query, tagForSector: this.form.tagForSector },
        sorts: null
      })
      this.tagLoading = false
      this.textTagList = resData.records
    },
    handleRemove (a, b) {
      this.fileList.forEach((item, index) => {
        if (item.accessUri === a.accessUri) {
          this.fileList.splice(index, 1)
        }
      })
      const arr = b.map((item) => item.accessUri)
      this.form.pic = arr.join(',')
    },
    onSuccess (res) {
      if (!res.success) {
        this.$message.error('文件上传失败')
        return this.fileList.splice(this.fileList.length - 1, 1)
      }
      this.fileList.push({
        ...res.data,
        url: process.env.VUE_APP_API_IMG + res.data.accessUri
      })
      const arr = []
      this.fileList.forEach((item) => {
        arr.push(item.accessUri)
      })
      this.form.pic = arr.join(',')
    },
    onExceed () {
      this.$message.warning('最多只能上传3张图片')
    },
    beforeUpload (file) {
      if (file.size / 1024 / 1024 > 5) {
        this.$message.warning('上传图片大小不能超过5mb')
        return false
      }
      const videoCount = this.fileList.filter((f) => this.isVideo(f.accessUri)).length
      if (/video\//.test(file.type) && videoCount >= 1) {
        this.$message.warning('只能上传一个视频文件')
        return false // 阻止上传超过 1 个视频文件
      }

      return true
    },
    // 手动上传文件
    async httpRequest (file) {
      const formData = new FormData()
      formData.append('file', file.file)

      const uploadUrl = !this.isVideo(file.name) ? this.base1 : this.base // 根据文件类型选择上传接口

      try {
        // 使用 axios 发送上传请求

        const response = await request.post(uploadUrl, formData, {
          headers: { 'Content-Type': 'multipart/form-data' }
        })
        response.success = true
        response.data = response
        // 成功后将文件添加到文件列表
        this.onSuccess(response, file)
      } catch (error) {
        console.log(error)
        this.$message.error('文件上传失败')
      }
    }
  }
}
</script>

<style scoped>
.el-select-dropdown__item {
  height: auto !important;
}
.upload-item {
  position: relative;
  display: inline-block;
  margin: 10px;
}

.upload-img {
  width: 120px;
  height: 120px;
  border-radius: 8px;
}

.upload-video-preview {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 120px;
  height: 120px;
  background-color: #f1f1f1;
  border-radius: 8px;
  cursor: pointer;
  text-align: center;
}

.upload-video-preview i {
  font-size: 30px;
  color: #333;
}

.delete-btn {
  position: absolute;
  top: 0;
  right: 0;
}

.video-player {
  width: 100%;
  height: 100%;
}
</style>
